import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export function trackAdFoxBannerClick(jsonQuery: IJsonQuery) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'AdFox_banner',
    event: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      extra: {
        trap_type: 'AdFox',
        bannerName: 'Adfox ТГБ баннер',
        trapid: 'Adfox ТГБ баннер',
      },
    },
  });
}

export function trackAdFoxBannerView(jsonQuery: IJsonQuery) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'AdFox_banner',
    event: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      extra: {
        trap_type: 'AdFox',
        bannerName: 'Adfox ТГБ баннер',
        trapid: 'Adfox ТГБ баннер',
      },
    },
  });
}
